import type { ITransactionsStatusFilter } from "@app/dashboard/types/innerLayout/transactions";
import type { TFunction } from "i18next";

export const transactionsStatusFilters = (t: TFunction): ITransactionsStatusFilter[] => ([
  { id: "all_transaction", name: "all", label: t('innerLayout.transactionsPage.allTransactions') },
  { id: "successful", name: "success", label: t('innerLayout.transactionsPage.success') },
  { id: "pending", name: "pending", label: t('innerLayout.transactionsPage.pending') },
  { id: "declined", name: "failed", label: t('innerLayout.transactionsPage.declined') },
]);